import React from 'react'

import { Typography } from '@material-ui/core'

import Image from 'artkive/components/Image'
import routes from 'artkive/utils/routes'

import CardsPreview from 'images/ecom/about/CardsPreview.jpg'
import PhotokivePreview from 'images/ecom/about/PhotokivePreview.jpg'
import CardkiveLogo from 'images/ecom/brand/CardkiveLogo.svg'
import PhotokiveLogo from 'images/ecom/brand/PhotokiveLogo.svg'

import { ImageWrap } from './ProductsCarousel.style'

export const PRODUCT_SLIDES = [
  {
    href: routes.cardkive,
    linkText: 'cardkive.co',
    trackerOptions: { product: 'cards_by_artkive' },
    img: (
      <ImageWrap>
        <Image src={CardkiveLogo} style={{ height: 44, width: 'auto' }} />
      </ImageWrap>
    ),
    preview: CardsPreview,
    text: (
      <Typography>
        Transform your greeting cards into a gorgeous keepsake book, showcasing messages from your loved ones on any
        special occasion, from weddings and milestone birthdays, to baby showers and more.
      </Typography>
    ),
  },
  {
    href: routes.photokive,
    linkText: 'photokive.com',
    trackerOptions: { product: 'photokive' },
    img: (
      <ImageWrap>
        <Image src={PhotokiveLogo} style={{ height: 22, width: 'auto' }} />
      </ImageWrap>
    ),
    preview: PhotokivePreview,
    text: (
      <Typography variant='body1'>
        Photokive digitizes your precious family photo albums so all your memories are safely stored in the cloud and
        accessible wherever you are. No need to take apart albums. Just put everything in our box and send it back. With
        the Photokive Guarantee, we’ll reprint photo books at no cost if anything is ever lost.
      </Typography>
    ),
  },
]
